
class HomeContact {
    private formContainer: HTMLElement | null;
    private confirmMessage: HTMLElement | null;

    constructor() {
        this.formContainer = document.querySelector<HTMLElement>('.contact .wpcf7');
        this.confirmMessage = document.querySelector<HTMLElement>('.confirm-message');

        if (!this.formContainer || !this.confirmMessage) {
            return;
        }
        this.confirmMessage.style.display = 'none';

        this.formContainer.addEventListener(
            'wpcf7mailsent',
            this.handleMailSent.bind(this) as EventListener
        );
    }

    private handleMailSent(event: Event): void {
        if (!this.formContainer || !this.confirmMessage) {
            return;
        }
        this.formContainer.style.display = 'none';
        this.confirmMessage.style.display = 'block';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new HomeContact();
});